import { EVENT_STATUS } from '@hedepy/common/enums/EVENT'
import type { Event } from '@hedepy/common/schemas/modules/event/event'
import dayjs from 'dayjs'

export const groupEvents = <T extends Pick<Event, 'startDate' | 'endDate' | 'status'>>(events: T[] = []) => {
  const futureEvents: T[] = []
  const pastEvents: T[] = []
  const otherEvents: T[] = []

  events.forEach((event) => {
    if (dayjs(event.endDate).isAfter(dayjs()) && event.status === EVENT_STATUS.RESERVED) {
      futureEvents.push(event)
    } else if (event.status === EVENT_STATUS.COMPLETED) {
      pastEvents.push(event)
    } else if (![EVENT_STATUS.PRE_BOOKING, EVENT_STATUS.DENIED].includes(event.status)) {
      otherEvents.push(event)
    }
  })

  const overviewEvents = pastEvents
    .concat(otherEvents)
    .sort((a, b) => (dayjs(a.startDate).isBefore(b.startDate) ? 1 : -1))

  return { futureEvents, pastEvents, overviewEvents }
}
